import Vue from "vue";
import VueAnalytics from "vue-analytics";
import VueHead from "vue-head";
import App from "./App.vue";
import router from "./router";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/analytics";
import "firebase/database";
import VueMaterial from "vue-material";
import "vue-material/dist/vue-material.min.css";
import "vue-material/dist/theme/default.css";
import "./registerServiceWorker";
import dayjs from "dayjs";
import "dayjs/locale/fr-ca";
dayjs.locale("fr-ca");

Vue.config.productionTip = false;

const isProd = process.env.NODE_ENV === "production";

Vue.use(VueMaterial);
Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_TRACKING_ID,
  router,
  debug: {
    enabled: !isProd,
    sendHitTask: isProd
  }
});
Vue.use(VueHead);

let app = "";
const config = {
  apiKey: process.env.VUE_APP_API_KEY,
  authDomain: process.env.VUE_APP_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_DATABASE_URL,
  projectId: process.env.VUE_APP_PROJECT_ID,
  storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_APP_ID,
  measurementId: process.env.VUE_APP_MEASUREMENT_ID
};

firebase.initializeApp(config);
firebase.analytics();

firebase.auth().onAuthStateChanged(user => {
  if (!app) {
    app = new Vue({
      router,
      render: h => h(App)
    }).$mount("#app");
  }

  if (user) {
    // console.log("Signed in anonymously!");
  }
});

export const EventBus = new Vue({
  data: () => ({
    initialized: false,
    rinks: {}
  }),
  created() {
    this.loadRinks();
  },
  methods: {
    loadRinks() {
      firebase
        .database()
        .ref("/rinks/")
        .once("value", this.setRinks);
    },
    setRinks(snapshot) {
      this.rinks = snapshot.val();

      this.initialized = true;
      EventBus.$emit("initialized");
    },
    createGeoJson(rinks) {
      var geojson = {
        name: "Rinks",
        type: "FeatureCollection",
        features: []
      };
      for (let rinkId in rinks) {
        let rink = rinks[rinkId];
        let feature = {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [rink.lng, rink.lat]
          },
          properties: {
            id: rinkId,
            name: rink.name || "",
            description: rink.description || "",
            address: rink.address || "",
            type: rink.type || ""
          }
        };

        geojson.features.push(feature);
      }

      // console.log(JSON.stringify(geojson));
    },
    addRink(id, rink) {
      this.rinks[id] = rink;
    },
    getRink(id) {
      return this.rinks[id];
    },
    async getRinkHistory(name) {
      let snapshot = await firebase
        .database()
        .ref("/history")
        .child(name)
        .orderByKey()
        .startAt("2018-10-01")
        .once("value");
      let history = snapshot.val();
      let lastOpeningDate = null;
      for (let key in history) {
        let val = history[key];
        if (val[0] == "1") {
          lastOpeningDate = key;
          break;
        }
      }
      return lastOpeningDate;
    },
    async getRinkLastYearWeekHistory(name) {
      let cursorDate = dayjs().set('y', (dayjs().year() - 1));
      let startDate = cursorDate.format('YYYY-MM-DD');
      let endDate = cursorDate.add(6, 'd').format('YYYY-MM-DD');

      let snapshot = await firebase
        .database()
        .ref("/history")
        .child(name)
        .orderByKey()
        .startAt(startDate)
        .endAt(endDate)
        .once("value");
      let history = snapshot.val();
      
      return history;
    }
  }
});
